module.exports = __webpack_public_path__ + "img/hero@2x.5e3f5a3f.webp";